export default __webpack_public_path__ + "static/media/2.3f3ad150.webp";